// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// #####################################################

const DataRelationship = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const userRelationship = useSelector(
		(state) => state.userProfileMain.relationship
	);

	// #####################################################

	return (
		userRelationship !== null && (
			<Block>
				<Text>{t("filtersAndSelectors:relationshipLabel")}:</Text>{" "}
				<Text bold>
					{t(`filtersAndSelectors:relationship.${userRelationship}`)}
				</Text>
			</Block>
		)
	);
};

// #####################################################

export default DataRelationship;

// #####################################################
